const DirectDebit = ({ width, height, className, fillColor }: ControlPanelProps) => (
  <svg
    className={className}
    width={width}
    height={height}
    viewBox='0 0 84 26'
    fill={fillColor}
    xmlns='http://www.w3.org/2000/svg'
    xlinkHref='http://www.w3.org/1999/xlink'
  >
    <rect width='84' height='26' fill='url(#pattern0)' />
    <defs>
      <pattern id='pattern0' patternContentUnits='objectBoundingBox' width='1' height='1'>
        <use xlinkHref='#image0_130:8972' transform='translate(0 -0.0246548) scale(0.00854701 0.0276134)' />
      </pattern>
      <image
        id='image0_130:8972'
        width='117'
        height='38'
        xlinkHref={
          'data:image/png;base64,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'
        }
      />
    </defs>
  </svg>
);

export type ControlPanelProps = {
  fillColor: string;
  className?: string;
  width: string | number;
  height: string | number;
};

DirectDebit.defaultProps = {
  width: 84,
  height: 26,
  fillColor: 'none',
};

export default DirectDebit;
